/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define,no-var,vars-on-top */

import { EVENTS } from '../../../app/constants/events';
import { HEROKU_BOOMERANG_BAR_HEIGHT } from '../../../app/constants/app';

xplenty.directive('mainWrapper', [
  '$rootScope',
  '$state',
  '$window',
  '$timeout',
  function ($rootScope, $state, $window, $timeout) {
    return {
      restrict: 'C',

      link(scope, element) {
        const minWidth = 1200;
        const sidebarMenuWidth = 50;
        const sidebarSubmenuWidth = 170;
        const navbarHeight = 48;
        const headerHeight = 80;
        let topPadding = 0;

        const $wrapper = element;
        const $sidebarWrapper = element.find('.sidebar-wrapper');
        const $pageContentWrapper = element.find('.page-content-wrapper');
        const $pageScrollWrapper = element.find('.page-scroll-wrapper');
        const $overlay = element.find('.sidebar-overlay');

        scope.isOpen = false;
        scope.isMobile = false;
        scope.hasHeader = false;

        if ($rootScope.user && $rootScope.user.settings) {
          scope.hasHeader = true;
        }

        scope.toogleSidebar = function () {
          scope.isOpen = !scope.isOpen;
          resize();
        };

        var resize = function () {
          if ($('body').hasClass('heroku-boomerang-loaded')) {
            topPadding = HEROKU_BOOMERANG_BAR_HEIGHT;
          } else {
            topPadding = 0;
          }

          let sidebarWidth = sidebarMenuWidth;

          const mainWidth = $window.innerWidth < minWidth ? minWidth : $window.innerWidth;

          if ($state.current.name.indexOf('app.account.settings') > -1) {
            sidebarWidth = sidebarMenuWidth + sidebarSubmenuWidth;
          }

          scope.isMobile = mainWidth < 768;

          $wrapper.css({
            width: mainWidth,
            height: $window.innerHeight - topPadding,
            top: topPadding,
          });

          $overlay.css({
            width: mainWidth,
            height: $window.innerHeight - topPadding,
          });

          const mainSize = {
            width: mainWidth - (!scope.isOpen && !scope.isMobile ? sidebarWidth : 0),
            height: $window.innerHeight - (scope.hasHeader ? headerHeight : 0) - topPadding,
          };

          $rootScope.mainSize = mainSize;

          $sidebarWrapper.css({
            left: scope.isOpen || !scope.isMobile ? 0 : sidebarWidth * -1,
            width: sidebarWidth,
            height: scope.isMobile ? $window.innerHeight - navbarHeight - topPadding : $window.innerHeight - topPadding,
            top: scope.isMobile ? navbarHeight : 0,
          });

          $pageContentWrapper.css({
            left: !scope.isMobile ? sidebarWidth : 0,
            width: mainWidth - (!scope.isOpen && !scope.isMobile ? sidebarWidth : 0),
            height: $window.innerHeight - topPadding,
          });

          $pageScrollWrapper.css(mainSize);

          $pageScrollWrapper.perfectScrollbar('update');

          $rootScope.$broadcast(EVENTS.LAYOUT_RESIZE);
        };

        angular.element($window).on('resize', resize);
        angular.element($window).on('orientationchange', resize);

        $timeout(() => {
          resize();
        }, 0);

        $pageScrollWrapper.perfectScrollbar();

        $pageScrollWrapper.on('ps-y-reach-end', function () {
          $rootScope.$broadcast(EVENTS.SCROLL_REACH_END);
        });

        scope.$on(EVENTS.SCROLL_DISABLE, function () {
          $pageScrollWrapper.perfectScrollbar('destroy');
        });

        scope.$on(EVENTS.SCROLL_ENABLE, function () {
          $pageScrollWrapper.perfectScrollbar();
        });

        scope.$on(EVENTS.SCROLL_UPDATE, function () {
          $pageScrollWrapper.perfectScrollbar('update');
        });

        scope.$on('$stateChangeStart', function () {
          if (scope.isOpen) {
            scope.toogleSidebar();
          }
        });

        scope.$on('$stateChangeSuccess', function (e, newState, oldState) {
          if (newState.name === 'app.account.package') {
            $pageScrollWrapper.perfectScrollbar('destroy');
          } else {
            $pageScrollWrapper.perfectScrollbar();
          }
        });

        scope.$on('$stateChangeSuccess', () => {
          $timeout(() => {
            resize();
          }, 0);
        });
      },
    };
  },
]);
